import Analytics from "features/analytics/components";
import AnalyticsDetail from "features/analytics/components/AnalyticsDetailPage";
import AppUsers from "features/appUsers/components";
import ApprovedPages from "features/approvedPages/components";
import PublicPresentation from "features/auth/publicPresentationViewCall";
import Saved from "features/compare/components/saved";
import Contact from "features/contact/components";
import CreateGraph from "features/createGraphs/components";
import CreateStudySessions from "features/createStudySessions/components";
import StudySessions from "features/createStudySessions/components/studySessions";
import Dashboard from "features/dashboard/components";
import ACCOUNTS from "features/dashboard/components/ACCOUNTS";
import Presentation from "features/presentation/components";
import PresentationDetails from "features/presentation/components/presentationDetailPage";
import PresentationTable from "features/presentation/components/presentationTable";
import ImportedQuestionsListing from "features/importedQuestions/components";
import ViewImportedQuestion from "features/importedQuestions/components/viewImportedQuestion";
import QuestionsListing from "features/questions/components";
import AddEditQuestionPage from "features/questions/components/questionFormPage";
import ViewScriptQuestion from "features/questions/components/viewScriptQuestion";
import QuizListing from "features/quiz/listing";
import QuizResult from "features/quiz/result";
import TakeQuiz from "features/quiz/takeQuiz";
import AddScriptForm from "features/script/components/addScriptForm";
import EditedPages from "features/script/components/editedPages";
import FavoriteListing from "features/script/components/favoritesScripts";
import HiddenPages from "features/script/components/hiddenPages";
import MobileScriptListing from "features/script/components/mobileScriptListing";
import ScriptDetails from "features/script/components/scriptDetails";
import ScriptFeedback from "features/script/components/scriptFeedback";
import ScriptListing from "features/script/components/scriptListing";
import ScriptTemplateSettings from "features/templateSettings/components";
import ScriptTemplateSettingsForm from "features/templateSettings/components/templateSettingForm";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  ACCOUNTS_PATH,
  ADD_SCRIPT_PATH,
  ANALYTICS_DETAIL_PATH,
  ANALYTICS_EXPLANATION_PATH,
  ANALYTICS_PATH,
  ANALYTICS_SCRIPT_PATH,
  ANALYTICS_SPECIALTY_PATH,
  ANALYTICS_TOPIC_PATH,
  ANSWERED_QUESTIONS,
  APPROVED_PAGES,
  APP_USERS,
  CONTACT_US,
  CREATE_GRAPH,
  CREATE_STUDY_SESSION,
  CREATE_TEST_FORM,
  DEFAULT_PATH,
  EDITED_PAGES,
  EDIT_SCRIPT_PATH,
  FAVORITE_PAGES,
  HIDDEN_PAGES,
  IMPORTED_QUESTIONS_LISTING,
  IMPORTED_QUESTIONS_VIEW,
  PRESENTATION_ADD_PATH,
  PRESENTATION_DETAIL_PATH,
  PRESENTATION_DETAIL_VIEW_PUBLIC_PATH,
  PRESENTATION_EDIT_PATH,
  PRESENTATION_PATH,
  SAVED,
  SCRIPT,
  SCRIPT_ADD_QUESTIONS,
  SCRIPT_DETAIL_PATH,
  SCRIPT_EDIT_QUESTIONS,
  SCRIPT_FEEDBACK_PATH,
  SCRIPT_QUESTIONS_LISTING,
  SCRIPT_QUIZ_LISTING,
  SCRIPT_QUIZ_PATH,
  SCRIPT_QUIZ_RESULT_PATH,
  SCRIPT_TEMPLATE_SETTINGS_FORM_PATH,
  SCRIPT_TEMPLATE_SETTINGS_PATH,
  SCRIPT_VIEW_QUESTIONS,
  STUDY_SESSION,
} from "./app-paths";
import CreateTestForm from "features/test/createTestForm";
import AnsweredQuestions from "features/test/answeredQuestions";
import Feed from "features/community/components/Feed";
import People from "features/community/components/People";
import Leaderboard from "features/community/components/Leaderboard";
import Profile from "features/profile/components";
import Compare from "features/profile/components/Compare";
import Notifications from "features/community/components/Notifications";
import Followers from "features/profile/components/Followers";
import Following from "features/profile/components/Following";
import {
  COMMUNITY_ROOT,
  COMMUNITY_FEED,
  COMMUNITY_PEOPLE,
  COMMUNITY_LEADERBOARD,
  NOTIFICATIONS_PATH,
  USER_PROFILE,
  USER_COMPARE,
  USER_FOLLOWERS,
  USER_FOLLOWING,
} from "./app-paths";
const getAppRoutes = () => {
  const isMobile = useSelector((state) => state?.app?.isMobile);
  return [
    {
      path: DEFAULT_PATH,
      element: <Dashboard />,
      name: "dashboard",
    },
    {
      path: ACCOUNTS_PATH,
      element: <ACCOUNTS />,
      name: "accounts",
    },
    {
      path: ADD_SCRIPT_PATH,
      element: <AddScriptForm />,
      name: "addScript",
    },
    {
      path: EDIT_SCRIPT_PATH,
      element: <AddScriptForm />,
      name: "editScript",
    },
    {
      path: SCRIPT_DETAIL_PATH,
      element: <ScriptDetails />,
      name: "scriptDetail",
    },
    {
      path: SCRIPT,
      element: isMobile ? <MobileScriptListing /> : <ScriptListing />,
      name: "script",
    },
    {
      path: PRESENTATION_PATH,
      element: <PresentationTable />,
      name: "presentation",
    },
    {
      path: PRESENTATION_DETAIL_PATH,
      element: <PresentationDetails />,
      name: "presentationDetail",
    },
    {
      path: PRESENTATION_ADD_PATH,
      element: <Presentation />,
      name: "presentationAdd",
    },
    {
      path: PRESENTATION_EDIT_PATH,
      element: <Presentation />,
      name: "presentationEdit",
    },
    {
      path: CONTACT_US,
      element: <Contact />,
      name: "contactus",
    },
    {
      path: APPROVED_PAGES,
      element: <ApprovedPages />,
      name: "approvedpages",
    },
    {
      path: CREATE_GRAPH,
      element: <CreateGraph />,
      name: "creategraph",
    },
    {
      path: ANALYTICS_PATH,
      element: <Analytics attribute="specialty" />,
      name: "analytics",
    },
    {
      path: ANALYTICS_SPECIALTY_PATH,
      element: <Analytics attribute="specialty" />,
      name: "analytics-specialty",
    },
    {
      path: ANALYTICS_SCRIPT_PATH,
      element: <Analytics attribute="script" />,
      name: "analytics-script",
    },
    {
      path: ANALYTICS_TOPIC_PATH,
      element: <Analytics attribute="topic" />,
      name: "analytics-topic",
    },
    {
      path: ANALYTICS_EXPLANATION_PATH,
      element: <Analytics attribute="explanation" />,
      name: "analytics-explanation",
    },
    {
      path: ANALYTICS_DETAIL_PATH,
      element: <AnalyticsDetail />,
      name: "analytics-detail",
    },

    {
      path: CREATE_STUDY_SESSION,
      element: <CreateStudySessions />,
      name: "createStudySessions",
    },
    {
      path: HIDDEN_PAGES,
      element: <HiddenPages />,
      name: "hiddenPages",
    },
    {
      path: EDITED_PAGES,
      element: <EditedPages />,
      name: "editedPages",
    },
    {
      path: FAVORITE_PAGES,
      element: <FavoriteListing />,
      name: "favoritePPages",
    },
    {
      path: APP_USERS,
      element: <AppUsers />,
      name: "app-users",
    },
    {
      path: SCRIPT_FEEDBACK_PATH,
      element: <ScriptFeedback />,
      name: "script-feedback",
    },
    {
      path: SAVED,
      element: <Saved />,
      name: "saved",
    },
    {
      path: STUDY_SESSION,
      element: <StudySessions />,
      name: "studysessions",
    },
    {
      path: PRESENTATION_DETAIL_VIEW_PUBLIC_PATH,
      element: <PublicPresentation />,
      name: "publicPresentationDetails",
    },
    {
      path: SCRIPT_TEMPLATE_SETTINGS_PATH,
      element: <ScriptTemplateSettings />,
      name: "scriptTemplateSettings",
    },
    {
      path: SCRIPT_TEMPLATE_SETTINGS_FORM_PATH,
      element: <ScriptTemplateSettingsForm />,
      name: "scriptTemplateSettingsForm",
    },
    {
      path: SCRIPT_QUIZ_LISTING,
      element: <QuizListing />,
      name: "tests",
    },
    {
      path: ANSWERED_QUESTIONS,
      element: <AnsweredQuestions />,
      name: "answered-questions",
    },
    {
      path: SCRIPT_QUIZ_PATH,
      element: <TakeQuiz />,
      name: "Quiz",
    },
    {
      path: SCRIPT_QUIZ_RESULT_PATH,
      element: <QuizResult />,
      name: "QuizResult",
    },
    {
      path: SCRIPT_QUESTIONS_LISTING,
      element: <QuestionsListing />,
      name: "questions",
    },
    {
      path: SCRIPT_ADD_QUESTIONS,
      element: <AddEditQuestionPage />,
      name: "script-add-question",
    },
    {
      path: SCRIPT_EDIT_QUESTIONS,
      element: <AddEditQuestionPage />,
      name: "script-edit-question",
    },
    {
      path: SCRIPT_VIEW_QUESTIONS,
      element: <ViewScriptQuestion />,
      name: "script-view-question",
    },
    {
      path: IMPORTED_QUESTIONS_LISTING,
      element: <ImportedQuestionsListing />,
      name: "imported-questions",
    },
    {
      path: IMPORTED_QUESTIONS_VIEW,
      element: <ViewImportedQuestion />,
      name: "imported-question-view",
    },
    {
      path: CREATE_TEST_FORM,
      element: <CreateTestForm />,
      name: "create-test",
    },
    {
      path: COMMUNITY_ROOT,
      element: <Navigate replace to={COMMUNITY_FEED} />,
      name: "community-root-redirect",
    },
    {
      path: COMMUNITY_FEED,
      element: <Feed />,
      name: "community-feed",
    },
    {
      path: COMMUNITY_PEOPLE,
      element: <People />,
      name: "community-people",
    },
    {
      path: COMMUNITY_LEADERBOARD,
      element: <Leaderboard />,
      name: "community-leaderboard",
    },
    {
      path: NOTIFICATIONS_PATH,
      element: <Notifications />,
      name: "notifications",
    },
    {
      path: USER_COMPARE,
      element: <Compare />,
      name: "user-compare",
    },
    {
      path: USER_PROFILE,
      element: <Profile />,
      name: "user-profile",
    },
    {
      path: USER_FOLLOWERS,
      element: <Followers />,
      name: "user-followers",
    },
    {
      path: USER_FOLLOWING,
      element: <Following />,
      name: "user-following",
    },
  ];
};

export default getAppRoutes;
